import React, { useState } from "react";
import { allHobbies } from "../dummy-data/hobbies"; // Assume this is your list of all hobbies

const UserHobbies = ({ userData, setUserData }) => {
	const [currentHobby, setCurrentHobby] = useState("");
	// Handle adding a hobby
	const addHobby = (e) => {
		const selectedHobbity = e.target.value;
		setCurrentHobby(selectedHobbity);

		if (selectedHobbity && !userData?.hobbies?.includes(selectedHobbity)) {
			const hobbyToAdd = allHobbies.find((hobby) => hobby.name === selectedHobbity);
			const updatedHobbies = userData?.hobbies ? [...userData?.hobbies, hobbyToAdd] : [hobbyToAdd];
			if (updatedHobbies.length > 5) {
				updatedHobbies.pop(); // Remove the last hobby if there are more than 5
			}
			const updatedUserData = { ...userData, hobbies: updatedHobbies };
			setUserData(updatedUserData);
			setCurrentHobby(""); // Reset dropdown
		}
	};

	// Handle removing a hobby
	const removeHobby = (hobbyName) => {
		const updatedHobbies = userData?.hobbies.filter((h) => h.name !== hobbyName);
		const updatedUserData = { ...userData, hobbies: updatedHobbies };
		setUserData(updatedUserData);
	};

	return (
		<div>
			<label htmlFor="hobbies" className="form-label">
				<i className="bi bi-stars"></i> Hobbies
			</label>
			<div className="input-group mb-2">
				<select className="form-select" value={currentHobby} onChange={(e) => addHobby(e)}>
					<option value="" disabled>
						Select hobbies (max 5)...
					</option>
					{allHobbies?.map((hobby, index) => (
						<option key={index} value={hobby.name}>
							{hobby.name}
						</option>
					))}
				</select>
			</div>

			<div>
				<ul className="list-group">
					{userData?.hobbies?.map((hobby, index) => (
						<li
							key={index}
							className="list-group-item d-flex justify-content-between align-items-center"
							style={{ padding: "0 0 0 10px" }}
						>
							<div>
								<i className={`bi ${hobby.icon} me-2`}></i>
								{hobby.name}
							</div>
							<button
								className="btn btn-danger btn-sm"
								onClick={() => removeHobby(hobby.name)}
								style={{ padding: "0", height: "30px", width: "30px" }}
							>
								<i className="bi bi-trash"></i>
							</button>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default UserHobbies;
